import React from "react";
import './CallToAction.css'

const click = ()=>{
  window.location.href = 'https://w.app/MegalotoTrimmerBuda';
 }

const CallToAction = () => (
  <section className="cta-section">
    <h2>¡Reserva tu número ahora y asegura tu lugar!</h2>
    <button className="cta-button" onClick={click}>Quiero Participar</button>
  </section>
);

export default CallToAction;
